<template>
  <div class="k-panel">
    <van-panel :title="title" :desc="desc">
      <slot>contents</slot>
      <slot name="footer">
          footers
      </slot>
    </van-panel>
  </div>
</template>

<script>
  export default {
    name: 'k-panel',
    props: ['title', 'desc']
  }

</script>
